import { Skeleton } from "@/components/ui/skeleton";

export const PropertyDetailSkeleton = () => (
  <div className="min-h-screen bg-background">
    <div className="container mx-auto px-4 md:px-6 py-6 md:py-8">
      <Skeleton className="h-9 w-32 mb-4" />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2 h-[400px] mb-8">
        <Skeleton className="md:col-span-2 md:row-span-2 rounded-lg" />
        <Skeleton className="rounded-lg hidden md:block" />
        <Skeleton className="rounded-lg hidden md:block" />
        <Skeleton className="rounded-lg hidden md:block" />
        <Skeleton className="rounded-lg hidden md:block" />
      </div>
      <div className="mb-6 space-y-3">
        <div className="flex items-center gap-3">
          <Skeleton className="h-6 w-24 rounded-full" />
          <Skeleton className="h-5 w-48" />
        </div>
        <Skeleton className="h-9 w-80" />
        <Skeleton className="h-5 w-64" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-8">
          <Skeleton className="h-[350px] w-full rounded-lg" />
          <Skeleton className="h-48 w-full rounded-lg" />
        </div>
        <div className="space-y-4">
          <Skeleton className="h-48 w-full rounded-lg" />
          <Skeleton className="h-32 w-full rounded-lg" />
        </div>
      </div>
    </div>
  </div>
);
